import type { ReactNode } from "react";
import { useProjects } from "../context/ProjectContext";

export function TopBar({ crumbs, actions }: { crumbs: ReactNode; actions?: ReactNode }) {
  const { active } = useProjects();
  return (
    <div className="topbar">
      <div className="crumbs">
        <span className="muted">{active?.name ?? "—"}</span>
        <span className="faint"> / </span>
        {crumbs}
      </div>
      <div className="row">{actions}</div>
    </div>
  );
}
